import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Logo, SupportButton } from '_common/components';

import styles from './SecondaryAuthPageContainer.module.scss';

export const TEST_IDS = {
  feedback: 'feedback_container',
} as const;

type SecondaryAuthPageContainerProps = {
  title: TranslationId;
  description: TranslationId;
  children: ReactNode;
};

const SecondaryAuthPageContainer = ({
  title,
  description,
  children,
}: SecondaryAuthPageContainerProps) => {
  // REDUX
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <Logo expanded color="blue" testId="auth-header-logo" />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <FormattedMessage id={title} />
          </div>
          <div className={styles.description}>
            <FormattedMessage id={description} />
          </div>
          {children}
        </div>
      </div>
      <SupportButton />
    </div>
  );
};

export default SecondaryAuthPageContainer;
